import { TResponseItemWrapper } from "../../common/types/common";
import { Dashboard } from "../../common/types/dashboard";
import { apiClient } from "../apiClient";

export const getDashboardDetails = async (): Promise<TResponseItemWrapper<Dashboard>> => {
    return apiClient.post(`/Dashboard/GetDashboardDetail`);
};
